import React, { useState, useEffect } from "react";
import lionVideo from "../assets/vid4.mp4";
import elephantVideo from "../assets/vid2.mp4";
import {
  FaCalendarAlt,
  FaMapMarkedAlt,
  FaInfoCircle,
  FaDollarSign,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import rhinoVideo from "../assets/vid3.mp4";
import leopardVideo from "../assets/vid1.mp4";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import safariBg from "../assets/af4.jpg";
import { FaUser, FaFlag, FaQuoteRight } from "react-icons/fa";
import lionThumb from "../assets/vid2.mp4";
import elephantThumb from "../assets/elep.mp4";
import buffaloThumb from "../assets/buffa.mp4";
import leopardThumb from "../assets/leaop.mp4";
import rhinoThumb from "../assets/rhin.mp4";
import { Divider, message } from "antd";
import { Container, Row, Col, Carousel, Card } from "react-bootstrap";
import maasaiImg from "../assets/des3.jpg";
import dianiImg from "../assets/des2.jpg";
import kenyaImg from "../assets/des1.jpg";
import nakuruImg from "../assets/des4.jpg";
import { getDocs, collection } from "firebase/firestore/lite";
import { db } from "../firebase/firebase-config";

function Home() {
  const whatsappLink = "https://wa.me/+254706019613";
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const heroVideos = [lionVideo, elephantVideo, rhinoVideo, leopardVideo];
  const reviews = [
    {
      name: "Emily R.",
      country: "USA",
      feedback:
        "WangoTrailSafaris gave me the most magical safari experience! The guides were knowledgeable and friendly. Highly recommended!",
      image: require("../assets/1.jpg"),
    },
    {
      name: "James K.",
      country: "UK",
      feedback:
        "From start to finish, everything was well organized. I loved the personalized itinerary and the breathtaking wildlife encounters.",
      image: require("../assets/2.jpg"),
    },
    {
      name: "Amina M.",
      country: "Kenya",
      feedback:
        "Local adventures with a personal touch! I was amazed by the cultural experiences and warm hospitality. Thank you, WangoTrails!",
      image: require("../assets/3.jpg"),
    },
    {
      name: "Sophia L.",
      country: "Canada",
      feedback:
        "WangoTrailSafaris exceeded my expectations! The landscapes were stunning, and the team made the whole experience unforgettable.",
      image: require("../assets/14.jpg"),
    },
    {
      name: "Carlos T.",
      country: "Spain",
      feedback:
        "An incredible journey into the heart of nature! The attention to detail in every aspect of the safari was remarkable. Will definitely book again!",
      image: require("../assets/15.jpg"),
    },
    {
      name: "Olivia W.",
      country: "Australia",
      feedback:
        "The safari was nothing short of magical. I felt completely immersed in the wildlife, and the team made sure I had the best experience. Highly recommend!",
      image: require("../assets/11.jpg"),
    },
    {
      name: "Michael B.",
      country: "USA",
      feedback:
        "WangoTrailSafaris made my dream safari come true. I loved every minute of the trip, from the friendly guides to the incredible wildlife sightings.",
      image: require("../assets/9.jpg"),
    },
    {
      name: "Nia G.",
      country: "South Africa",
      feedback:
        "What an amazing adventure! The safari was well-paced and full of surprises. The guides were incredibly passionate and shared so much knowledge.",
      image: require("../assets/8.jpg"),
    },
  ];

  const [currentReviewIndex, setCurrentReviewIndex] = useState(0);
  const reviewsToShow = 4;
  const handleMouseEnter = () => {};
  const handleMouseLeave = () => {};
  const reviewChangeInterval = 5000;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentReviewIndex(
        (prevIndex) => (prevIndex + reviewsToShow) % reviews.length
      );
    }, reviewChangeInterval);

    return () => clearInterval(interval);
  }, []);

  const currentReviews = reviews.slice(
    currentReviewIndex,
    currentReviewIndex + reviewsToShow
  );
  
  const handleVideoEnd = () => {
    setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % heroVideos.length);
  };
  
  const [packagesList, setPackagesList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchPackages();
  }, []);

  async function fetchPackages() {
    try {
      setIsLoading(true);
      const packagesCollectionRef = collection(
        db,
        "sacco",
        "qjULheMl3MrBXfGHbBl0",
        "packages"
      );
      const packagesSnapshot = await getDocs(packagesCollectionRef);
      const fetchedPackages = packagesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPackagesList(fetchedPackages);
    } catch (err) {
      message.error("Error fetching packages: " + err.message);
    } finally {
      setIsLoading(false);
    }
  }
  
  const destinations = [
    {
      name: "Maasai Mara",
      desc: "Wildlife safaris and the Great Migration",
      img: maasaiImg,
    },
    {
      name: "Diani Beach",
      desc: "Pristine white sands and turquoise waters",
      img: dianiImg,
    },
    {
      name: "Mount Kenya",
      desc: "Second-highest peak in Africa",
      img: kenyaImg,
    },
    {
      name: "Lake Nakuru",
      desc: "Home of flamingos and rhinos",
      img: nakuruImg,
    },
  ];

  const bigFiveVideos = [
    {
      title: "The Majestic Lion",
      src: "https://www.youtube.com/embed/CmCTrwPzJxg",
      thumbnail: lionThumb,
    },
    {
      title: "Elephant Herd in the Wild",
      src: "https://www.youtube.com/embed/8Z1eMy4Fo3A",
      thumbnail: elephantThumb,
    },
    {
      title: "Cape Buffalo Charge",
      src: "https://www.youtube.com/embed/6Fq4FGy_tQc",
      thumbnail: buffaloThumb,
    },
    {
      title: "Elusive Leopard Hunt",
      src: "https://www.youtube.com/embed/Y0vUhTSMxWk",
      thumbnail: leopardThumb,
    },
    {
      title: "Black Rhino Encounter",
      src: "https://www.youtube.com/embed/OwGhQxCFhw4",
      thumbnail: rhinoThumb,
    },
  ];

  return (
    <div style={{ fontFamily: "sans-serif", lineHeight: 1.6 }}>
      {/* Navbar */}
      <Navbar />
      <div style={styles.floatingCTA}>
        <a
          href="https://mail.google.com/mail/?view=cm&fs=1&to=wangotrailsafaris@gmail.com&su=Booking%20Inquiry&body=Hi,%0D%0A%0D%0AI%20want%20to%20book%20assist%20me"
          style={styles.ctaButton}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          target="_blank"
          rel="noopener noreferrer"
        >
          Book Your Tour
        </a>
      </div>

      {/* Hero Video Section */}
      <section style={styles.hero}>
        <div style={styles.videoRow}>
          <video
            key={currentVideoIndex}
            src={heroVideos[currentVideoIndex]}
            autoPlay
            muted
            playsInline
            onEnded={handleVideoEnd}
            style={styles.video}
          />
        </div>
        <div style={styles.heroOverlay}>
          <p style={{ fontSize: 38, fontWeight: "bold" }}>
            Explore the world with WangoTrailSafaris
          </p>
          <p style={styles.heroText}>Book your next unforgettable trip now</p>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.heroButton}
          >
            Chat With Us on WhatsApp
          </a>
        </div>
      </section>
      
      <section style={styles.whyUs}>
        <h2 style={styles.sectionTitle}>Why Travel With WangoTrailSafaris?</h2>
        <div style={styles.whyGrid}>
          <div style={{ ...styles.whyCard, backgroundColor: "#1C8E58" }}>
            <i style={styles.icon} className="fas fa-user-tie"></i>
            <h3>Expert Guides</h3>
            <p>Our guides know the terrain, culture, and hidden gems.</p>
          </div>
          <div style={{ ...styles.whyCard, backgroundColor: "#F57C00" }}>
            <i style={{ ...styles.icon, color: "white" }} className="fas fa-headset"></i>
            <h3>Best Customer Service</h3>
            <p>We prioritize your comfort and satisfaction.</p>
          </div>
          <div style={{ ...styles.whyCard, backgroundColor: "#00796B" }}>
            <i style={styles.icon} className="fas fa-tags"></i>
            <h3>Affordable Packages</h3>
            <p>We offer great deals tailored to your budget.</p>
          </div>
        </div>
      </section>

      {/* Destinations */}
      <section style={styles.destinationsSection}>
        <h2 style={styles.sectionTitle}>Top Destinations</h2>
        <div style={styles.marqueeContainer}>
          <div style={styles.marqueeTrack}>
            {destinations.concat(destinations).map((place, index) => (
              <div key={index} style={styles.card}>
                <img
                  src={place.img}
                  alt={place.name}
                  style={styles.cardImage}
                />
                <div style={styles.cardContent}>
                  <h3>{place.name}</h3>
                  <p>{place.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      <section style={styles.groupSafariCard}>
        <div style={styles.groupSafariOverlay}>
          <h2 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
            Scheduled Group Safaris
          </h2>
          <p
            style={{
              fontSize: "1.2rem",
              maxWidth: "600px",
              textAlign: "center",
              marginBottom: "1.5rem",
            }}
          >
            Discounted & Magical Adventures with Other Travelers!
          </p>
          <div style={{ textAlign: "center", marginTop: "2rem" }}>
            <Link
              to="/packages"
              style={{
                backgroundColor: "#C49B6C",
                color: "white",
                padding: "10px 20px",
                fontSize: "1rem",
                borderRadius: "5px",
                textDecoration: "none",
                fontWeight: "bold",
              }}
            >
              See All Our Packages
            </Link>
          </div>
        </div>
      </section>

      {/* Styled Traveler Reviews Section */}
      <section style={styles.reviewsSection}>
        <div style={styles.reviewsContainer}>
          <h2 style={styles.reviewsTitle}>
            What Our Travelers Say
          </h2>
          <p style={styles.reviewsSubtitle}>
            Real experiences from real adventurers who explored with us
          </p>

          <div style={styles.reviewsCarouselWrapper}>
            {/* Gradient overlays for fade effect */}
            <div style={styles.gradientLeft} />
            <div style={styles.gradientRight} />

            <div style={styles.reviewsCarouselTrack}>
              {reviews.concat(reviews).map((review, index) => (
                <div key={index} style={styles.reviewCardWrapper}>
                  <div style={styles.reviewCard}>
                    <div style={styles.reviewCardHeader}>
                      <img
                        src={review.image}
                        alt={review.name}
                        style={styles.reviewAvatar}
                      />
                      <div style={styles.reviewUserInfo}>
                        <h4 style={styles.reviewName}>{review.name}</h4>
                        <div style={styles.reviewCountry}>
                          <FaFlag style={styles.flagIcon} />
                          <span>{review.country}</span>
                        </div>
                      </div>
                    </div>
                    <div style={styles.reviewCardBody}>
                      <FaQuoteRight style={styles.quoteIcon} />
                      <p style={styles.reviewFeedback}>"{review.feedback}"</p>
                    </div>
                    <div style={styles.reviewStars}>
                      <span>★</span><span>★</span><span>★</span>
                      <span>★</span><span>★</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section style={styles.contactCTA}>
        <h2>Ready to Plan Your Next Adventure?</h2>
        <br />
        <a
          href={whatsappLink}
          style={styles.heroButton}
          target="_blank"
          rel="noopener noreferrer"
        >
          Chat with Us on WhatsApp
        </a>
      </section>
      
      {/* Modern Marquee Section */}
      <div style={styles.modernMarqueeWrapper}>
        <div style={styles.modernMarqueeContainer}>
          <div style={styles.marqueeTrack} className="marquee-track">
            {/* First set */}
            <span style={styles.marqueeItem}>
              <span style={styles.marqueeIcon}>🌟</span>
              <span style={styles.marqueeText}>Latest Offers & Exclusive Deals</span>
              <span style={styles.marqueeDivider}>•</span>
            </span>
            <span style={styles.marqueeItem}>
              <span style={styles.marqueeIcon}>🌍</span>
              <span style={styles.marqueeText}>Explore 50+ Dream Destinations</span>
              <span style={styles.marqueeDivider}>•</span>
            </span>
            <span style={styles.marqueeItem}>
              <span style={styles.marqueeIcon}>🎉</span>
              <span style={styles.marqueeText}>Special Packages - Save Up to 30%</span>
              <span style={styles.marqueeDivider}>•</span>
            </span>
            <span style={styles.marqueeItem}>
              <span style={styles.marqueeIcon}>🏖️</span>
              <span style={styles.marqueeText}>Adventure Awaits - Book Now!</span>
              <span style={styles.marqueeDivider}>•</span>
            </span>
            <span style={styles.marqueeItem}>
              <span style={styles.marqueeIcon}>✈️</span>
              <span style={styles.marqueeText}>Flight + Hotel Packages Available</span>
              <span style={styles.marqueeDivider}>•</span>
            </span>
            <span style={styles.marqueeItem}>
              <span style={styles.marqueeIcon}>🐘</span>
              <span style={styles.marqueeText}>Wildlife Safaris - Best Prices</span>
              <span style={styles.marqueeDivider}>•</span>
            </span>
            <span style={styles.marqueeItem}>
              <span style={styles.marqueeIcon}>🏨</span>
              <span style={styles.marqueeText}>Luxury Accommodation Deals</span>
              <span style={styles.marqueeDivider}>•</span>
            </span>
            <span style={styles.marqueeItem}>
              <span style={styles.marqueeIcon}>🎯</span>
              <span style={styles.marqueeText}>Customized Itineraries Just for You</span>
              <span style={styles.marqueeDivider}>•</span>
            </span>
            {/* Duplicate for seamless loop */}
            <span style={styles.marqueeItem}>
              <span style={styles.marqueeIcon}>🌟</span>
              <span style={styles.marqueeText}>Latest Offers & Exclusive Deals</span>
              <span style={styles.marqueeDivider}>•</span>
            </span>
            <span style={styles.marqueeItem}>
              <span style={styles.marqueeIcon}>🌍</span>
              <span style={styles.marqueeText}>Explore 50+ Dream Destinations</span>
              <span style={styles.marqueeDivider}>•</span>
            </span>
            <span style={styles.marqueeItem}>
              <span style={styles.marqueeIcon}>🎉</span>
              <span style={styles.marqueeText}>Special Packages - Save Up to 30%</span>
              <span style={styles.marqueeDivider}>•</span>
            </span>
            <span style={styles.marqueeItem}>
              <span style={styles.marqueeIcon}>🏖️</span>
              <span style={styles.marqueeText}>Adventure Awaits - Book Now!</span>
              <span style={styles.marqueeDivider}>•</span>
            </span>
            <span style={styles.marqueeItem}>
              <span style={styles.marqueeIcon}>✈️</span>
              <span style={styles.marqueeText}>Flight + Hotel Packages Available</span>
              <span style={styles.marqueeDivider}>•</span>
            </span>
            <span style={styles.marqueeItem}>
              <span style={styles.marqueeIcon}>🐘</span>
              <span style={styles.marqueeText}>Wildlife Safaris - Best Prices</span>
              <span style={styles.marqueeDivider}>•</span>
            </span>
            <span style={styles.marqueeItem}>
              <span style={styles.marqueeIcon}>🏨</span>
              <span style={styles.marqueeText}>Luxury Accommodation Deals</span>
              <span style={styles.marqueeDivider}>•</span>
            </span>
            <span style={styles.marqueeItem}>
              <span style={styles.marqueeIcon}>🎯</span>
              <span style={styles.marqueeText}>Customized Itineraries Just for You</span>
              <span style={styles.marqueeDivider}>•</span>
            </span>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}

const styles = {
  navbar: {
    backgroundColor: "#333",
    padding: "1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "white",
  },

  contactCTA: {
    padding: "3rem 1rem",
    textAlign: "center",
    backgroundColor: "#67B7D1",
    color: "white",
  },
  
  logo: { fontSize: "1.5rem" },
  navLinks: { listStyle: "none", display: "flex", gap: "1rem" },
  link: { color: "white", textDecoration: "none" },
  
  hero: {
    position: "relative",
    height: "90vh",
    overflow: "hidden",
    width: "100vw",
  },
  
  videoRow: {
    width: "100%",
    height: "100%",
  },
  
  video: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  
  heroOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    padding: "0 1rem",
    textAlign: "center",
  },

  heroText: {
    fontSize: "1.2rem",
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  
  heroButton: {
    backgroundColor: "#25D366",
    color: "white",
    padding: "0.75rem 1.5rem",
    borderRadius: "5px",
    textDecoration: "none",
    fontSize: "1rem",
  },

  groupSafariCard: {
    position: "relative",
    backgroundImage: `url(${safariBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "400px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
  },

  groupSafariOverlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    color: "white",
    padding: "2rem",
    borderRadius: "10px",
    textAlign: "center",
  },

  whyUs: {
    padding: "2rem 1rem",
    backgroundColor: "#ffffff",
  },

  whyGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "1.5rem",
    padding: "1rem",
  },
  
  whyCard: {
    padding: "1rem",
    color: "white",
    borderRadius: "10px",
    textAlign: "center",
  },
  
  icon: {
    fontSize: "2rem",
    marginBottom: "0.5rem",
  },
  
  sectionTitle: {
    fontSize: "2rem",
    textAlign: "center",
    marginBottom: "1.5rem",
  },
  
  destinationsSection: { padding: "2rem" },
  marqueeContainer: { overflow: "hidden", width: "100%" },
  
  marqueeTrack: {
    display: "flex",
    flexDirection: "row",
    animation: "scroll 15s linear infinite",
    whiteSpace: "nowrap",
  },
  
  card: {
    width: "300px",
    flexShrink: 0,
    marginRight: "1rem",
    backgroundColor: "#fff",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  
  cardImage: { width: "100%", height: "200px", objectFit: "cover" },
  cardContent: { padding: "1rem" },
  
  packages: {
    padding: "4rem 2rem",
    backgroundColor: "#f8f9fa",
    width: "100%",
  },
  
  heroSection: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    color: "#fff",
    textAlign: "center",
    padding: "120px 20px",
    marginBottom: "50px",
  },
  
  heroTitle: {
    fontSize: "3rem",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  
  heroSubtitle: {
    fontSize: "1.3rem",
    maxWidth: "600px",
    margin: "0 auto",
  },
  
  packagesSection: {
    padding: "60px 5%",
    width: "100%",
  },
  
  packagesList: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "30px",
  },
  
  packageCard: {
    width: "300px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
    overflow: "hidden",
    transition: "transform 0.3s",
  },
  
  packageImage: {
    width: "100%",
    height: "200px",
    objectFit: "cover",
  },
  
  packageDetails: {
    padding: "20px",
  },
  
  packageTitle: {
    fontSize: "1.4rem",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  
  packageDescription: {
    fontSize: "0.95rem",
    color: "#555",
    marginBottom: "15px",
  },
  
  packageMeta: {
    marginBottom: "15px",
  },
  
  packageMetaItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "0.95rem",
    color: "#444",
    marginBottom: "8px",
  },
  
  ctaButton: {
    padding: "15px 30px",
    backgroundColor: "#ff6347",
    color: "#fff",
    fontSize: "1.1rem",
    borderRadius: "30px",
    textDecoration: "none",
    fontWeight: "bold",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.3)",
  },
  
  whySection: {
    padding: "60px 5%",
    backgroundColor: "#fff",
  },
  
  whyList: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "30px",
  },
  
  reasonCard: {
    width: "300px",
    padding: "20px",
    backgroundColor: "#f9f9f9",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    textAlign: "center",
  },
  
  destinationsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: "1rem",
  },
  
  bigFive: { padding: "2rem 0", backgroundColor: "#eee" },
  
  videoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "1rem",
  },
  
  videoCard: {
    backgroundColor: "white",
    padding: "1rem",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  
  testimonials: { padding: "2rem 0" },
  
  testimonialGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "1rem",
  },

  viewAllButtonContainer: {
    textAlign: "center",
    marginTop: "20px",
  },

  // Styled Reviews Section
  reviewsSection: {
    padding: "80px 0",
    backgroundColor: "#f8f9fa",
  },

  reviewsContainer: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
  },

  reviewsTitle: {
    textAlign: "center",
    marginBottom: "15px",
    fontSize: "2.5rem",
    fontWeight: "700",
    color: "#2C3E50",
    letterSpacing: "-0.5px",
  },

  reviewsSubtitle: {
    textAlign: "center",
    color: "#7F8C8D",
    fontSize: "1.1rem",
    marginBottom: "50px",
    maxWidth: "600px",
    marginLeft: "auto",
    marginRight: "auto",
  },

  reviewsCarouselWrapper: {
    overflow: "hidden",
    width: "100%",
    position: "relative",
  },

  gradientLeft: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "80px",
    height: "100%",
    background: "linear-gradient(to right, #f8f9fa, transparent)",
    zIndex: 2,
    pointerEvents: "none",
  },

  gradientRight: {
    position: "absolute",
    top: 0,
    right: 0,
    width: "80px",
    height: "100%",
    background: "linear-gradient(to left, #f8f9fa, transparent)",
    zIndex: 2,
    pointerEvents: "none",
  },

  reviewsCarouselTrack: {
    display: "flex",
    animation: "scrollReviews 35s linear infinite",
    width: "200%",
  },

  reviewCardWrapper: {
    flex: "0 0 25%",
    padding: "15px",
    boxSizing: "border-box",
  },

  reviewCard: {
    backgroundColor: "white",
    borderRadius: "16px",
    padding: "25px",
    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
    height: "100%",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    border: "1px solid rgba(0, 0, 0, 0.04)",
    display: "flex",
    flexDirection: "column",
  },

  reviewCardHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: "15px",
  },

  reviewAvatar: {
    width: "60px",
    height: "60px",
    objectFit: "cover",
    borderRadius: "50%",
    marginRight: "15px",
    border: "3px solid #f0f0f0",
  },

  reviewUserInfo: {
    flex: 1,
  },

  reviewName: {
    fontSize: "1rem",
    fontWeight: "600",
    color: "#2C3E50",
    margin: 0,
    marginBottom: "4px",
  },

  reviewCountry: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "0.85rem",
    color: "#7F8C8D",
  },

  flagIcon: {
    fontSize: "0.9rem",
    color: "#3498db",
  },

  reviewCardBody: {
    flex: 1,
    marginBottom: "15px",
  },

  quoteIcon: {
    fontSize: "1.2rem",
    color: "#C49B6C",
    marginBottom: "8px",
    opacity: 0.7,
  },

  reviewFeedback: {
    fontSize: "0.95rem",
    lineHeight: "1.6",
    color: "#34495E",
    margin: 0,
  },

  reviewStars: {
    display: "flex",
    gap: "4px",
    fontSize: "1.1rem",
    color: "#F39C12",
    letterSpacing: "2px",
  },

  floatingCTA: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: 1000,
  },

  testimonialCard: {
    backgroundColor: "white",
    padding: "1rem",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  
  footer: {
    backgroundColor: "#333",
    color: "white",
    padding: "1rem",
    textAlign: "center",
  },

  // Modern Marquee Styles
  modernMarqueeWrapper: {
    width: "100%",
    overflow: "hidden",
    backgroundColor: "#2C3E50",
    padding: "12px 0",
    borderTop: "3px solid #C49B6C",
    borderBottom: "3px solid #C49B6C",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  },

  modernMarqueeContainer: {
    maxWidth: "100%",
    overflow: "hidden",
    position: "relative",
  },

  marqueeTrack: {
    display: "flex",
    animation: "marqueeScroll 25s linear infinite",
    whiteSpace: "nowrap",
    gap: "10px",
  },

  marqueeItem: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "0 20px",
    color: "#FFFFFF",
    fontSize: "1rem",
    fontWeight: "500",
    letterSpacing: "0.3px",
  },

  marqueeIcon: {
    fontSize: "1.3rem",
    display: "inline-block",
    animation: "bounceIcon 2s ease-in-out infinite",
  },

  marqueeText: {
    fontSize: "0.95rem",
    fontWeight: "500",
    color: "#ECF0F1",
    textShadow: "0 1px 2px rgba(0,0,0,0.1)",
  },

  marqueeDivider: {
    color: "#C49B6C",
    fontSize: "1.2rem",
    fontWeight: "bold",
    margin: "0 10px",
    opacity: 0.6,
  },
};

// Add CSS animations
const styleTag = document.createElement("style");
styleTag.textContent = `
  @keyframes scroll {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }

  @keyframes scrollReviews {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }

  @keyframes marquee {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }

  @keyframes marqueeScroll {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }

  @keyframes bounceIcon {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-3px); }
  }

  .marquee-track:hover {
    animation-play-state: paused;
  }

  @media (max-width: 768px) {
    .why-grid {
      flex-direction: column;
      gap: 1rem;
    }

    .hero-title {
      font-size: 1.5rem !important;
    }

    .hero-text {
      font-size: 1rem !important;
    }

    .cta-button {
      font-size: 0.9rem !important;
      padding: 10px 16px !important;
    }

    .group-safari-card h2 {
      font-size: 1.5rem !important;
    }

    .group-safari-card p {
      font-size: 1rem !important;
      padding: 0 1rem;
    }

    .card {
      min-width: 240px !important;
    }

    .video {
      height: 300px !important;
    }

    [style*="reviewCardWrapper"] {
      flex: 0 0 50% !important;
    }

    .reviews-title {
      font-size: 1.8rem !important;
    }

    .marquee-item {
      font-size: 0.85rem !important;
      padding: 0 12px !important;
    }

    .marquee-text {
      font-size: 0.8rem !important;
    }

    .marquee-icon {
      font-size: 1rem !important;
    }

    .marquee-divider {
      font-size: 1rem !important;
      margin: 0 5px !important;
    }

    .modern-marquee-wrapper {
      padding: 8px 0 !important;
    }
  }

  @media (max-width: 576px) {
    .floating-cta a {
      font-size: 14px;
      padding: 8px 12px;
    }

    [style*="reviewCardWrapper"] {
      flex: 0 0 100% !important;
    }

    .gradient-left,
    .gradient-right {
      display: none !important;
    }

    .marquee-item {
      font-size: 0.75rem !important;
      padding: 0 8px !important;
    }

    .marquee-text {
      font-size: 0.7rem !important;
    }

    .marquee-icon {
      font-size: 0.85rem !important;
    }

    .marquee-track {
      gap: 5px !important;
    }
  }
`;
document.head.appendChild(styleTag);

export default Home;